import { c as _c } from "react/compiler-runtime";
import { PersonCard } from '@/components/Molecules/PersonCard/PersonCard';
import { RelatedSidebar } from '@/components/Molecules/RelatedSidebar/RelatedSidebar';
import useTranslation from '@/hooks/useTranslation';
import type { IRole } from '@/interfaces';
interface IRolesProps {
  people?: IRole[];
}
export const Roles = t0 => {
  const $ = _c(7);
  const {
    people
  } = t0;
  const {
    t
  } = useTranslation("events");
  if (!people) {
    return null;
  }
  let t1;
  if ($[0] !== people || $[1] !== t) {
    let t2;
    if ($[3] !== t) {
      t2 = group => ({
        title: t(`SessionDetail.${group.role}`, {
          count: group.people.length
        }),
        items: group.people,
        itemRenderer: _temp
      });
      $[3] = t;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = people.map(t2);
    $[0] = people;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <RelatedSidebar open={true} lists={t1} />;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp(person) {
  return <PersonCard person={person} />;
}